<template>
  <HPopup class="h-playground-popup"
          ref="popup"
          v-show="visible">
    <div class="h-playground-popup-body">
      <div v-if="!selectedGameId">
        <HRank></HRank>
        <div class="footer">
          <button ref="button"
                  v-click-sound-button
                  class="h-btn normal"
                  @click="handlePlay">
            消消乐
          </button>
          <button ref="button"
                  v-click-sound-button
                  class="h-btn normal"
                  @click="handleClose">
            离开
          </button>
        </div>
      </div>
      <div v-else class="game-container h-outer-border around-4 bw3">
        <div class="game-header popup-header">
          <p>{{ GAME_NAME[selectedGameId] }}</p>
          <div v-click-sound-button class="btn-leave" @click="handleLeaveGame"></div>
        </div>
        <div class="iframe-wrapper h-outer-border around-4 bw2">
          <iframe :src="gameUrl" frameborder="0" scrolling="no" width="452" height="580">
          </iframe>
        </div>
      </div>
    </div>
  </HPopup>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import HPopup from '@/components/h-popup/index.vue'
  import HRank from './rank'
  import AudioCtrl from '@js/audio-ctrl'
  import AUDIO from '@/js/constants/AUDIO'

  const GAME_NAME = {
    1: '英雄无敌消消乐',
  }

  export default {
    beforeDestroy () {
      if (this.audioId) {
        AudioCtrl.stop(this.audioId)
      }
    },

    data () {
      return {
        GAME_NAME,
        selectedGameId: null,
        audioId: null,
      }
    },

    props: {
      visible: {
        type: Boolean,
        default: true
      },
      zIndex: {
        type: Number,
        default: 1000
      },
    },

    computed: {
      gameUrl () {
        return `https:${process.env.VUE_APP_BASE_URL}/g/${this.selectedGameId || 1}/index.html?v=2`
      },
    },

    async mounted () {
      this.$refs.popup.$el.style.zIndex = this.zIndex
      this.audioId = AudioCtrl.play({ url: AUDIO.SCENE.playground, loop: false })
    },

    methods: {
      ...mapActions('hero', [
        'getHeroInfo',
        'getBackpackItems',
        'getPrimarySkills',
        'getSecondarySkills',
      ]),

      ...mapActions('user', [
        'getUserInfo'
      ]),

      ...mapActions('gameSocket', [
        'appendSystemMessage'
      ]),

      handlePlay () {
        this.selectedGameId = 1
      },

      handleLeaveGame () {
        this.selectedGameId = null
      },

      handleClose () {
        this.$emit('close', false)
      },
    },

    components: {
      HPopup,
      HRank,
    }
  }
</script>

<style lang="stylus" scoped>
  .footer
    margin-top 30px
    display flex
    justify-content space-evenly
    .h-btn
      width 90px
      height 42px
      goldText1()
      border 2px solid $colorGold

  .game-header
    position relative
    padding 5px 0
    goldText1()
    p
      line-height 20px
    .btn-leave
      position absolute
      top 5px
      right 2px
      width 20px
      height 20px
      background-image imgURL("/img/btn/icon_close.png")
      background-repeat no-repeat
      background-size 100%
      transform-origin center
      transform scale(.9)
      filter drop-shadow(1px 1px 1px #000)
      &:hover
        cursor pointer
        transform scale(1)

  .game-container
    padding 4px

  .iframe-wrapper
    padding 2px

  iframe
    z-index 2
    position relative
    vertical-align top
    box-shadow 0 0 4px #212121

</style>
